// extracted by mini-css-extract-plugin
module.exports = {"box":"allGift_box_3lIkX","list":"allGift_list_3eDiv","item":"allGift_item_1VFMw"};